import { RolodexEntryType } from 'types/rolodex/rolodexEntries'

export enum KnowledgeDocumentInspectionType {
  VISUAL = 'Visual',
  THERMAL = 'Thermal',
  VIBRATION = 'Vibration',
  OIL_ANALYSIS = 'Oil Analysis',
  ULTRASONIC = 'Ultrasonic',
  OTHER = 'Other',
}

type OEMManualFields = {
  revision?: string
}

type NonGeckoInspectionReportFields = {
  inspection_types?: KnowledgeDocumentInspectionType[]
}

export type KnowledgeDocumentFields = OEMManualFields &
  NonGeckoInspectionReportFields & {
    instance_id: string | number
    page_number: string | number
  }

export type KnowledgeDocumentEntry = {
  entry: {
    id: string
    type: RolodexEntryType.KNOWLEDGE_DOCUMENT
    data: { fields: KnowledgeDocumentFields & Record<string, unknown> }
    updated_at: string
    last_updated_by: string
    tags: {
      [key: string]: string
    }
  }
}
